// Re-export interfaces from the Redux slice for backward compatibility
export type {
  RestaurantFinanceItem as Earnings,
  PayoutHistoryItem as Payouts,
  RestaurantFinanceDetails,
  PayoutReceipt,
  OrderItem
} from "../../../redux/restaurantFinance/restaurantFinanceSlice";

// Legacy interface for the view details modal
export interface EarningsView {
  name: string;
  totalEarnings: number;
  pendingPayouts: number;
  lastPayout: number;
  weeklyGrowth: string;
  commissionRate: number;
  nextPayout: string;
  totalOrders: number;
  status: string;
}

// Legacy interface for receipt modal
export interface PayoutReceiptLegacy {
  vendorDetails: {
    name: string;
    id: string;
    phone: string;
    email: string;
  };
  payoutInfo: {
    amount: string;
    date: string;
    bankName: string;
    accountNumber: string;
  };
  totalEarnings: string;
  deduction: string;
  netPayout: string;
}

// Helper functions to format data for backward compatibility with existing modals
export const formatFinanceDataForView = (restaurant: any, details: any): EarningsView => {
  return {
    name: restaurant.name,
    totalEarnings: details?.financialSummary?.restaurantEarnings || restaurant.totalEarnings || 0,
    pendingPayouts: details?.financialSummary?.pendingPayouts || restaurant.pendingPayouts || 0,
    lastPayout: 0, // This would need to be calculated from payout history
    weeklyGrowth: restaurant.growth || '0%',
    commissionRate: restaurant.commissionRate || 10,
    nextPayout: "TBD", // This would need to be calculated
    totalOrders: details?.orderStatistics?.allTime?.totalOrders || restaurant.totalOrders || 0,
    status: restaurant.status,
  };
};

export const formatPayoutReceiptForModal = (receipt: any): PayoutReceiptLegacy => {
  return {
    vendorDetails: {
      name: receipt?.restaurantDetails?.[0]?.name || "",
      id: receipt?.restaurantDetails?.[0]?.id || "",
      phone: "", // Not available in the API response
      email: "", // Not available in the API response
    },
    payoutInfo: {
      amount: receipt?.orderInfo?.totalAmount?.toString() || "0",
      date: receipt?.orderInfo?.orderDate || "",
      bankName: "", // Not available in the API response
      accountNumber: "", // Not available in the API response
    },
    totalEarnings: receipt?.orderInfo?.totalAmount?.toString() || "0",
    deduction: "0", // Not available in the API response
    netPayout: receipt?.orderInfo?.totalAmount?.toString() || "0",
  };
};

// Utility functions for number formatting
export const formatCurrency = (amount: number | string | null | undefined): string => {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : (amount || 0);
  
  if (isNaN(numAmount)) {
    return '₦0';
  }
  
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
  }).format(numAmount);
};

export const formatNumber = (num: number | string | null | undefined): string => {
  const numValue = typeof num === 'string' ? parseFloat(num) : (num || 0);
  
  if (isNaN(numValue)) {
    return '0';
  }
  
  return new Intl.NumberFormat('en-US').format(numValue);
};
